import AwesomeCart from "@cahaba/XDL/Icons/AwesomeCart";
import { addToCartButtonStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToCartButton";
import { css } from "styled-components";

addToCartButtonStyles.button = {
    css: css`
        width: 100%;
        margin: 15px -1px -1px 0;
    `,
    icon: {
        src: AwesomeCart,
        position: "left",
    },
    typographyProps: {
        transform: "uppercase",
    },
};
